import React from "react";

function App() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: 'sans-serif',
      padding: '20px',
      textAlign: 'center'
    }}>
      <img src="/icon.png" alt="NodoDigital Logo" style={{ maxWidth: '200px', marginBottom: '40px' }} />
      <h1 style={{ color: '#333' }}>¡Síguenos en LinkedIn!</h1>
      <p style={{ color: '#666', marginBottom: '30px', maxWidth: '400px' }}>
        Mantente al día con nuestras últimas noticias y actualizaciones siguiendo nuestra página de LinkedIn.
      </p>
      <a 
        href="https://www.linkedin.com/company/nododigital" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px',
          backgroundColor: '#0a66c2',
          color: 'white',
          padding: '12px 24px',
          borderRadius: '24px',
          textDecoration: 'none',
          fontWeight: 'bold',
          fontSize: '18px',
          transition: 'background-color 0.3s'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#004182'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0a66c2'}
      >
        <img src="/LinkedIn_icon.png" alt="LinkedIn" style={{ width: '24px', height: '24px' }} onError={(e) => e.currentTarget.style.display = 'none'} />
        Seguir a NodoDigital
      </a>
    </div>
  );
}

export default App;
